import React from 'react'

const Button = ({ onClick, fullWidth, textOnly, children, disabled, selected }) => {
  const onPress = e => {
    e.preventDefault()

    onClick && !disabled && onClick()
  }

  return (
    <a
      href="#"
      onClick={onPress}
      className={`Button ${fullWidth && 'fullWidth'} ${textOnly && 'textOnly'} ${disabled &&
        'disabled'} ${selected === false && 'unselected'} ${selected === true && 'selected'}`}
    >
      {selected === true ? <span>&#10003; &nbsp;</span> : null}
      {children}
    </a>
  )
}

export default Button
